import MDBox from "components/MDBox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import MDButton from "components/MDButton";
import { useState } from "react";
import MDBackdrop from "components/MDBackdrop";
import CloseIcon from '@mui/icons-material/Close';
import { useMaterialUIController } from "context";
import theme from "assets/theme";
import PopAddStart from "./PopAddStart";
import PopAddStop from "./PopAddStop";
import IconButton from '@mui/material/IconButton';
function PopAddMain(props) {
    const getValues = () => {
        return {
            tag_id: "",

            charger_id: "",
            vehicleId: "",
            connectorId: "",

            reason: ""
        };
    };
    const getValues1 = () => {
        return {
            charger_id: "",
            session_id: "",
            reason: ""
        };
    };

    const [values] = useState(getValues);
    const [values1] = useState(getValues1);
    const [controller] = useMaterialUIController();
    const { darkMode, sidenavColor } = controller;
    const [isDisabled, setIsDisabled] = useState(false);
    const [isDisabled2, setIsDisabled2] = useState(false);
    const [isBackdrop, setIsBackdrop] = useState(false);
    const { onClose } = props;



    const start = (event) => {
        event.preventDefault();
        setIsBackdrop(false);
        onClose(false);
        setIsDisabled(!isDisabled)
    }
    const handleClose = () => {
        onClose(false);
    };
    const stop = (event) => {
        event.preventDefault();
        setIsBackdrop(false);
        onClose(false);
        setIsDisabled2(!isDisabled2)

    };
    return (
        <>
            <PopAddStart
                isDialog={isDisabled}
                onClose={setIsDisabled}
                value={values}
                onStateChange={props.onStateChange}
            />
            <PopAddStop
                isDialog={isDisabled2}
                onClose={setIsDisabled2}
                value={values1}
                onStateChange={props.onStateChange}
            />
            <MDBackdrop isBackdrop={isBackdrop} />
            <Dialog open={props.isDialog} onClose={handleClose} fullWidth={false}   //  stop stretching
                PaperProps={{
                    sx: {
                        width: 360,     // exact width (adjust if needed)
                        borderRadius: "12px",
                    },
                }} >
                <DialogTitle style={darkMode ? { backgroundColor: "#202940", color: "#ffffff", display: "flex", alignItems: "center", justifyContent: "space-between" } : { theme, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    Start / Stop transaction
                    <IconButton aria-label="delete" onClick={handleClose} style={darkMode ? { color: "#ffffff" } : theme}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme}>
                    <MDBox pt={0} pb={0} px={3}>
                        <MDBox p={2} component="form" role="form" style={{ display: "flex", height: "30vh", flexDirection: "column", justifyContent: "space-around" }}>
                            <MDButton variant="gradient" color={sidenavColor} onClick={start}>
                                Start transaction
                            </MDButton>
                            <MDButton variant="gradient" color={sidenavColor}

                                onClick={stop}
                            >
                                Stop transaction
                            </MDButton>
                        </MDBox>
                    </MDBox>
                </DialogContent>
                <DialogActions style={darkMode ? { backgroundColor: "#202940", justifyContent: "space-evenly", color: "#ffffff" } : { theme, justifyContent: "space-evenly" }}>


                </DialogActions>
            </Dialog>
        </>
    );
}

export default PopAddMain;